import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import './i18n'; // Initialize i18n
import posthog from 'posthog-js';

posthog.init('phc_OekoEKsX8YClc3ha4GLBqXEuR6mjhWdRG1hDUjgXlbO', {
  api_host: 'https://app.posthog.com',
  autocapture: true,
  capture_pageview: true,
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);